import React, { useState, useEffect } from 'react';
import { FiCopy, FiCheck } from 'react-icons/fi';
import '../styles/JsonFormatter.css';
// @ts-ignore
import { jsonrepair } from 'jsonrepair';

const JsonFormatter = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [copied, setCopied] = useState(false);

const handleCopy = () => {
  navigator.clipboard.writeText(output).then(() => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  });
};


  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

 const handleFormat = () => {
  try {
    const repaired = jsonrepair(input); // <- repara estrutura
    const parsed = JSON.parse(repaired); // <- agora é válido
    const formatted = JSON.stringify(parsed, null, 2);
    setOutput(formatted);
  } catch (error) {
    setOutput(`❌ JSON inválido. Erro: ${error.message}`);
  }
};




  return (
    <div className="json-formatter">
      <h2>Formatador de JSON</h2>

      <textarea
        value={input}
        onChange={(e) => setInput(e.target.value)}
        rows={10}
        className="w-full p-2 border"
        placeholder="Cole seu JSON aqui..."
      />

      <button
        onClick={handleFormat}
        className="mt-2 p-2 bg-blue-500 text-white"
      >
        Formatar JSON

        
      </button>

      {output && (
    <div className="mt-4 w-full relative">
      <pre className="formatted-json-output">
        <button
          onClick={handleCopy}
          className="copy-button-inside"
          title="Copiar JSON"
        >
          <FiCopy />
        </button>
        {output}
      </pre>
    </div>
  )}

      {/* Google AdSense */}
      <div className="ad-container mt-4">
        <ins
          className="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client="ca-pub-1989683361613000"
          data-ad-slot="1234567890"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
    </div>
  );

};

export default JsonFormatter;
